module.exports = __webpack_public_path__ + "static/handshake-fa0b6b403fbd84bee9ec9f32bfc95369.jpg";